/**
 * Source tags of a studio row (CT-5570). The variant / label of each tag lives in
 * `PERMISSION_SOURCE_META` (copy.js); this file only holds the layout rule.
 */

/** Role tags shown on a studio row; the rest collapse into a "+N" tag with a tooltip (Oct 8 call). */
export const MAX_VISIBLE_ROLE_TAGS = 3;
